/**
 * @desc Ensure `dataId` / optional company segment match hydrated client access.
 *      Global with `02.` prefix so it runs after startup/modal globals and before
 *      `navigation-scope-gate` (lexicographic order).
 */
import Console from '~/utils/lib/core/console'
import { isEmpty, Maybe, notEmpty, propOr } from '~/utils/lib/core/prelude'
import { findCompany, findStructure, useStore_client_access } from '~/stores/client/access'
import { extractRouteCompanyCode } from '~/stores/layout/navigation'
import { ERRORS } from '~/utils/lib/layout/types'

const console = new Console('middleware:unknown-access')

export default defineNuxtRouteMiddleware(async (/** @type {import('~/utils/lib/core/types_').Route_} */ to) => {

  if (to.path === '/proxy') {
    console.log('proxy route, skipping access check')
    return
  }

  if (isEmpty(useStore_client_access().data)) {
    console.log('client access data not found, skipping access check')
    return
  }

  const rawDataId = to.params?.dataId
  if (rawDataId == null || rawDataId === '') {
    return
  }

  const structure_id = propOr('', 'dataId', to.params)
  const company_code = extractRouteCompanyCode(to)

  const accessData = useStore_client_access().data
  const mStructure = findStructure(accessData, structure_id)

  if (Maybe.isNothing(mStructure)) {
    console.error(`structure "${structure_id}" not found`)
    throw new Error(ERRORS.UNKNOWN_STRUCTURE)
  }

  const structure = Maybe.fromJust(mStructure)

  if (notEmpty(company_code)) {
    const mCompany = findCompany(structure, company_code)

    if (Maybe.isNothing(mCompany)) {
      console.error(`company "${company_code}" not found`)
      throw new Error(ERRORS.UNKNOWN_COMPANY)
    }
  }
})
